import { LinkTo } from '@ember/routing';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import WLoginDialog from 'login/components/w-login-dialog';
import type { ApplicationModel } from 'login/routes/application';

export default class ForgotPassword extends Component<{ Args: { model: ApplicationModel } }> {
  <template>
    <WLoginDialog
      @pageTitle={{t 'login.title.forgotPassword'}}
      @dialogTitle={{@model.logonParams.serviceName}}
      @version={{@model.version}}
    >
      <form class='form' method='post' action='forgotPassword'>
        <div class='explanation-line'>
          {{t 'login.forgotPasswordExplanation'}}
        </div>

        <div class='spacer-small'></div>

        <div class='inner-form'>
          <div class='line'>
            <input
              id='emailInput'
              type='text'
              name='username'
              autocomplete='username'
              placeholder={{t 'login.emailOrLogonNameLabel'}}
              autofocus
            />
          </div>

        </div>
        <div class='spacer'></div>

        <div class='expanded-line'>
          <button type='button' class='button'>
            <LinkTo class='link' @route='index' @model='?'>
              {{t 'login.cancelButton'}}
            </LinkTo>
          </button>

          <button type='submit' class='quick-button-right'>
            {{t 'login.submitButton'}}
          </button>
        </div>
      </form>
    </WLoginDialog>
  </template>
}
